"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeedbackRatingGroup = exports.StoreStatus = exports.Theme = exports.ECompanySize = void 0;
var ECompanySize;
(function (ECompanySize) {
    ECompanySize["Micro"] = "MICRO";
    ECompanySize["Small"] = "SMALL";
    ECompanySize["Medium"] = "MEDIUM";
    ECompanySize["Large"] = "LARGE";
})(ECompanySize || (exports.ECompanySize = ECompanySize = {}));
/**
 * These theme names were generated based on the primary color using the Name That Color vscode extension.
 * https://marketplace.visualstudio.com/items?itemName=guillaumedoutriaux.name-that-color
 */
//
var Theme;
(function (Theme) {
    Theme["Sushi"] = "SUSHI";
    Theme["PuertoRico"] = "PUERTO_RICO";
    Theme["SteelBlue"] = "STEEL_BLUE";
    Theme["Studio"] = "STUDIO";
    Theme["Cerise"] = "CERISE";
    Theme["BrickRed"] = "BRICK_RED";
    Theme["Tuscany"] = "TUSCANY";
    Theme["Dixie"] = "DIXIE";
    Theme["IrishCoffee"] = "IRISH_COFFEE";
    Theme["BaliHai"] = "BALI_HAI";
    Theme["Cobalt"] = "COBALT";
    Theme["CodGray"] = "COD_GRAY";
})(Theme || (exports.Theme = Theme = {}));
/**
 * Possible states of a store, might be changed by an admin, due to contract updates, or inactivity.
 */
var StoreStatus;
(function (StoreStatus) {
    /**
     * The store is active, with its contract in a valid state that allows it to operate normally.
     */
    StoreStatus["Active"] = "ACTIVE";
    /**
     * The store has been temporarily suspended, usually, it happens due to lack of payment.
     */
    StoreStatus["Suspended"] = "SUSPENDED";
    /**
     * The store hasn't been active recently, the store is set as inactive after 45 days without a login.
     */
    StoreStatus["Inactive"] = "INACTIVE";
    /**
     * The store has been archived and is no longer accessible, the store data was also archived or deleted.
     */
    StoreStatus["Archived"] = "ARCHIVED";
    /**
     * The store has been blocked due to some terms and conditions violation, it might get `Archived` if the violation isn't resolved after some time.
     */
    StoreStatus["Blocked"] = "BLOCKED";
})(StoreStatus || (exports.StoreStatus = StoreStatus = {}));
var FeedbackRatingGroup;
(function (FeedbackRatingGroup) {
    FeedbackRatingGroup["Detractor"] = "DETRACTOR";
    FeedbackRatingGroup["Passive"] = "PASSIVE";
    FeedbackRatingGroup["Promoter"] = "PROMOTER";
})(FeedbackRatingGroup || (exports.FeedbackRatingGroup = FeedbackRatingGroup = {}));
//# sourceMappingURL=store.js.map